import React , { useState }from 'react';
import { useMediaQuery } from 'react-responsive';
import {Col,Row,Carousel,Button} from 'antd';
import './Brand.css';

import Header from '../components/Header'
import Footer from '../components/Footer'

import logoBig from '../assets/images/logoBig.jpg'
import pic2 from '../assets/images/street.jpg' ;
import pic3 from '../assets/images/tokyo-tower-night.jpg' ;


// Section Component for reusable layout
const Section = ({title,picloc,children}) => (
  <Row className='section'>
    <Col span={12} className='section-picture'><img className='section-picture2' src={picloc} /></Col>
    <Col span={12} className='section-content'>
    <div className='section-content2'>
    <h2 className="section-title">{title}</h2>
    <div>{children}</div>
    </div>
  </Col>
  </Row>
);

const Who = () => (
    <Section id="who" title="About us" picloc={logoBig}>
      <p>NEOHO, a subsidiary of Dexing Investment Group, stands at the intersection of tradition and innovation, offering a global platform that merges the art of living, refined shopping, and cultural exchange. With a meticulous global perspective, NEOHO curates high-quality products and services that embody the essence of Oriental wisdom and modern aesthetics. 
      </p>
    </Section>
)

const Mission = () => (
  <Section id="mission" title="Our Mission" picloc={pic2}>
    <p>To provide a high-end service platform that harmonizes life, art, shopping, and culture, allowing the global community to experience the warmth of home and the beauty of art wherever they are.
</p>
  </Section>
);

const Vision = () => (
  <Section id="vision" title="Our Vision" picloc={pic3}>
    <p>To lead the global community into a new realm of quality living, driven by innovation, rooted in quality, and centered on culture.</p>
  </Section>
);

function Brand() {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  return (
    <div className="App">
      <Header />
      <main className='content'>
        {isMobile ? <MobileView /> : <DesktopView />}
      </main>
      <Footer />
    </div>
  );
}

function MobileView() {
  const [current, setCurrent] = useState('mail');
  const onClick = (e) => {
    console.log('click ', e);
    setCurrent(e.key);
  };
  return (
    <div className="App">
      <main className='content'>
        <div className="section-content">
          <h3>About us</h3>
          <p>NEOHO, a subsidiary of Dexing Investment Group, stands at the intersection of tradition and innovation, offering a global platform that merges the art of living, refined shopping, and cultural exchange. With a meticulous global perspective, NEOHO curates high-quality products and services that embody the essence of Oriental wisdom and modern aesthetics.</p>
  
          <h3>Our Mission</h3>
          <p>To provide a high-end service platform that harmonizes life, art, shopping, and culture, allowing the global community to experience the warmth of home and the beauty f art wherever they are.</p>
  
          <h3>Our Vision</h3>
          <p>To lead the global community into a new realm of quality living, driven by nnovation, rooted in quality, and centered on culture.</p>
          </div>
      </main>
    </div>
  );
}

function DesktopView() {
  const [current, setCurrent] = useState('mail');
  const onClick = (e) => {
    console.log('click ', e);
    setCurrent(e.key);
  };
  return (
    <div className="App">
      <main className='content'>
        <Who />
        <Mission />
        <Vision />
      </main>
    </div>
  );
}
export default Brand;
